(function(angular) {
    'use strict';

    angular.module('wtUi.wtDotsDropdown', []);
})(window.angular);
